
// This file is automatically generated by `generateVersionsJs` task. Any changes will be lost"
/* tslint:disable */
export const GoCDVersion = {
  "version"         : "26.2.0",
  "distVersion"     : "23216",
  "gitShortRevision": "a88de55fcd",
};

function stripLeadingPrefix(value: string, prefix: string) {
  return value.startsWith(prefix) ? value.substring(prefix.length) : value;
}

export function releaseNotesUrl() {
  return `https://www.gocd.org/releases#26.2.0`;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/26.2.0/${stripLeadingPrefix(suffix, '/')}`;
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/26.2.0/${stripLeadingPrefix(suffix, '#')}`;
}
